"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("@ag-grid-community/react");
const gridLocale_de_1 = __importDefault(require("../gridLocale.de"));
const gridUtils_1 = require("../gridUtils");
const GridColumnTypes_1 = __importDefault(require("../Common/GridColumnTypes"));
const errorNotification_1 = require("../../errorNotification");
const range_selection_1 = require("@ag-grid-enterprise/range-selection");
const client_side_row_model_1 = require("@ag-grid-community/client-side-row-model");
const clipboard_1 = require("@ag-grid-enterprise/clipboard");
const AuthContext_1 = require("../../Auth/AuthContext");
const api_1 = require("../../api");
const OrderHistoryColumns_1 = require("./OrderHistoryColumns");
const OrderHistoryGrid = ({ orderIds }, props) => {
    const [gridApi, setGridApi] = (0, react_1.useState)(null);
    const [, setGridColumnApi] = (0, react_1.useState)(null);
    const [rows, setRows] = (0, react_1.useState)([]);
    const [columns, setColumns] = (0, react_1.useState)([]);
    const { user } = (0, AuthContext_1.useAuth)();
    const orderHistoryApi = new api_1.OrderHistoryApi();
    const gridModules = [
        range_selection_1.RangeSelectionModule,
        client_side_row_model_1.ClientSideRowModelModule,
        clipboard_1.ClipboardModule,
    ];
    function onGridReady(params) {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        const fetchData = async () => {
            params.api.showLoadingOverlay();
            try {
                const data = await orderHistoryApi.index({ orderIds });
                params.api.setColumnDefs((0, OrderHistoryColumns_1.OrderHistoryColumns)());
                params.api.hideOverlay();
                params.api.showNoRowsOverlay();
                params.api.setRowData(data.items);
                if (data.items.length > 0) {
                    params.api.hideOverlay();
                }
            }
            catch (e) {
                if (e.response.status === 403) {
                    (0, errorNotification_1.notifyError)(e.response.data.message);
                }
                else {
                    (0, errorNotification_1.notifyError)(e.message);
                }
            }
            // params.api.hideOverlay();
        };
        fetchData().then(() => { });
    }
    const defaultColDef = {
        flex: 1,
        minWidth: 75,
        filter: true,
        resizable: true,
        sortable: true,
        floatingFilter: true,
        enablePivot: false,
        enableValue: false,
        enableRowGroup: false,
        cellClass: 'default',
    };
    const gridOptions = {
        enableRangeSelection: true,
        getRowNodeId: (data) => {
            return data.plant_option_id;
        },
        // isExternalFilterPresent: isExternalFilterPresent,
        // doesExternalFilterPass: doesExternalFilterPass,
        excelStyles: [
            {
                id: 'default',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'derived',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'header',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            }
        ],
    };
    const gridTable = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(react_2.AgGridReact
        // @ts-ignore
        , { 
            // @ts-ignore
            modules: gridModules, localeText: gridLocale_de_1.default, disableStaticMarkup: true, onGridReady: onGridReady, 
            // onFirstDataRendered={onFirstDataRendered}
            onCellKeyDown: gridUtils_1.onCellKeyDown, 
            // onCellEditingStarted={cellEditingStarted}
            // onCellEditingStopped={cellEditingStopped}
            rowSelection: 'multiple', suppressCopyRowsToClipboard: true, enableRangeSelection: true, undoRedoCellEditing: true, enableCellChangeFlash: true, animateRows: true, enableFillHandle: true, fillHandleDirection: 'y', gridOptions: gridOptions, columnDefs: columns, defaultColDef: defaultColDef, columnTypes: GridColumnTypes_1.default, rowData: rows, getRowNodeId: (data) => data.open_order_id, suppressLastEmptyLineOnPaste: true, overlayNoRowsTemplate: '<span class="p-4 border-2 border-primary-400 bg-info">Keine Bestellungen vorhanden!</span>' }));
    }, [rows, columns, gridApi]);
    return (react_1.default.createElement("div", { className: "ag-theme-balham flex flex-col w-full flex-1" },
        react_1.default.createElement("div", { className: 'mb-2 flex items-end space-x-4' },
            react_1.default.createElement("div", { className: 'max-w-lg' }),
            react_1.default.createElement("div", { className: 'space-x-2 flex flex-1' }),
            react_1.default.createElement("div", { className: 'space-x-1' })),
        gridTable));
};
exports.default = OrderHistoryGrid;
